import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://969547b97537bd1444ce2905aba49823@o193361.ingest.us.sentry.io/4508078018789376",
  debug: false,
  environment: "production",
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()